<div class="d-flex flex-wrap gap-4 mb-3">
  <app-mdb-button [text]="'MEETING_POINTS.NEW_MEETING_POINT'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewMeetingPointModal()" />
</div>

<div class="d-flex gap-3 align-items-start">
  <div style="flex: 0 0 40vw; height: 80vh; min-width: 0;">
    <app-meeting-points-map
      [center]="mapCenter()"
      [zoom]="10"
      [points]="meetingPoint()"
      (mapClicked)="onMapClicked($event)">
    </app-meeting-points-map>
  </div>

  <div class="bg-light border rounded" style="flex: 1 1 0; height: 80vh; min-width: 0; overflow: auto;">
    <app-meeting-points-table (deletedMeetingPoint)="onMeetingPointDeleted($event)"/>
  </div>
</div>
